import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {GetReceiveNoteFastTrackResponse} from '../types';

// eslint-disable-next-line no-restricted-syntax
const createMockDate = (dateString: string) => new Date(dateString);

const mockFastTrackResponseData: GetReceiveNoteFastTrackResponse = {
  receiveNoteItems: [
    {
      receiveNoteItemId: 'item1',
      catalogNumber: 'CAT123',
      manufacturerId: 'manufacturer1',
      name: 'Test Item 1',
      quantity: 5,
      unitId: 'unit1',
      quantityLeft: 3,
      isAccepted: false,
      fastTruckIssues: [
        {
          isSelected: false,
          isSelectionAllowed: true,
          fastTruckId: 'ft1',
          fastTruckItemId: 'fti1',
          fastTruckNumber: 'FT001',
          fastTruckDate: createMockDate('2023-01-15'),
          fastTruckQuantity: 2,
          fastTrackNote: 'Test note',
          customerOrderNumber: 'ORD001',
          customerOrderCreatedAt: createMockDate('2023-01-10'),
          customerOrderVehicleId: 'vehicle1',
          customerOrderCustomerId: 'customer1',
          fastTrackOriginEntityHeaderId: 'header1',
          fastTrackOriginEntityHeaderType: 'headerType1',
          fastTrackOriginEntityId: 'entity1',
          fastTrackOriginEntityType: 'entityType1',
          fastTrackOriginEntityHeaderServiceCaseId: 'case1',
        },
        {
          isSelected: true,
          isSelectionAllowed: true,
          fastTruckId: 'ft2',
          fastTruckItemId: 'fti2',
          fastTruckNumber: 'FT002',
          fastTruckDate: createMockDate('2023-01-16'),
          fastTruckQuantity: 1,
          fastTrackNote: 'Another test note',
          customerOrderNumber: 'ORD002',
          customerOrderCreatedAt: createMockDate('2023-01-11'),
          customerOrderVehicleId: 'vehicle2',
          customerOrderCustomerId: 'customer2',
          fastTrackOriginEntityHeaderId: 'header2',
          fastTrackOriginEntityHeaderType: 'headerType2',
          fastTrackOriginEntityId: 'entity2',
          fastTrackOriginEntityType: 'entityType2',
          fastTrackOriginEntityHeaderServiceCaseId: 'case2',
        },
      ],
    },
    {
      receiveNoteItemId: 'item2',
      catalogNumber: 'CAT456',
      manufacturerId: 'manufacturer2',
      name: 'Test Item 2',
      quantity: 3,
      unitId: 'unit2',
      quantityLeft: 1,
      isAccepted: true,
      fastTruckIssues: [
        {
          isSelected: false,
          isSelectionAllowed: true,
          fastTruckId: 'ft3',
          fastTruckItemId: 'fti3',
          fastTruckNumber: 'FT003',
          fastTruckDate: createMockDate('2023-01-17'),
          fastTruckQuantity: 1,
          fastTrackNote: 'Third test note',
          customerOrderNumber: 'ORD003',
          customerOrderCreatedAt: createMockDate('2023-01-12'),
          customerOrderVehicleId: 'vehicle3',
          customerOrderCustomerId: 'customer3',
          fastTrackOriginEntityHeaderId: 'header3',
          fastTrackOriginEntityHeaderType: 'headerType3',
          fastTrackOriginEntityId: 'entity3',
          fastTrackOriginEntityType: 'entityType3',
          fastTrackOriginEntityHeaderServiceCaseId: 'case3',
        },
      ],
    },
  ],
};

const emptyFastTrackResponseData: GetReceiveNoteFastTrackResponse = {
  receiveNoteItems: [],
};

const getReceiveNoteItemRefreshed = (server: SetupServerApi) =>
  server.use(http.get('*/warehouse/v1/receive-note/*/article-refresh', () => HttpResponse.json()));

const getReceiveNoteFastTrackResponseInterceptor = (
  server: SetupServerApi,
  isEmpty: boolean = false
) =>
  server.use(
    http.get('*/warehouse/v1/receive-note/*/fast-track', () =>
      HttpResponse.json(isEmpty ? emptyFastTrackResponseData : mockFastTrackResponseData)
    )
  );

const patchReceiveNoteFastTrackInterceptor = (
  server: SetupServerApi,
  shouldFail: boolean = false
) =>
  server.use(
    http.patch('*/warehouse/v1/receive-note/*/fast-track', () => {
      if (shouldFail) {
        return HttpResponse.json({error: 'Server error'}, {status: 500});
      }
      return new HttpResponse(null, {status: 204});
    })
  );

export const metadaWarehouseReceiveNoteApiMock = {
  getReceiveNoteItemRefreshed,
  getReceiveNoteFastTrackResponseInterceptor,
  patchReceiveNoteFastTrackInterceptor,
  mockFastTrackResponseData,
  emptyFastTrackResponseData,
};
